import { render } from "./editGWattMinLayerModal.vue?vue&type=template&id=45b7b24a&ts=true"
import script from "./editGWattMinLayerModal.vue?vue&type=script&lang=ts"
export * from "./editGWattMinLayerModal.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__